'use client'

import * as React from 'react'
import { InlineStaticVariant } from '@repo/web-ui/components/static-variants-renderer/inline/inline-static-variant'
import { LOGGED_OUT } from '@repo/web-ui/components/static-variants-renderer/utils/conditions'

export function SeoSectionInlineStaticVariantLoggedOut({ banner }: { banner: React.ReactNode }) {
  return (
    <InlineStaticVariant
      conditions={[LOGGED_OUT]}
      getVariant={({ conditionsMet }) => (conditionsMet ? <>{banner}</> : null)}
    />
  )
}
